import { render, staticRenderFns } from "./KioskTablePrint.vue?vue&type=template&id=96b785e6&"
import script from "./KioskTablePrint.vue?vue&type=script&lang=js&"
export * from "./KioskTablePrint.vue?vue&type=script&lang=js&"
import style0 from "./KioskTablePrint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KioskTablePrint.vue"
export default component.exports